// Retired: earlier releases stashed the Auth0 refresh token in the iOS Keychain / Android
// Keystore through capacitor-native-biometric, with no access control, so any script in the
// page could read it back. Nothing writes or reads that entry any more; this only deletes
// whatever an older release left behind. deleteCredentials never prompts (the entry was
// stored without biometric protection), treats "nothing stored" as success, and touches no
// other entry — so it is safe to run on every launch. Face ID itself (faceIdGate) is unaffected.

import { NativeBiometric } from "capacitor-native-biometric";
import { isMobileApp } from "./isMobileApp";

// The Keychain "server" the retired stash was written under.
const LEGACY_SERVER = "asksmart.refreshToken";

// Best-effort: an older binary without the plugin, or a store that refuses, changes nothing for the session.
export async function clearNativeRefreshToken(): Promise<void> {
  if (!isMobileApp()) return;
  try {
    await NativeBiometric.deleteCredentials({ server: LEGACY_SERVER });
  } catch (err) {
    console.log("[nativeTokenStore] deleteCredentials failed:", err);
  }
}
